import { tv } from "@pcln/horizon";
const recentSelectionVariants = tv({
    slots: {
        root: '@container relative',
        card: [
            'relative w-full overflow-hidden rounded-xl bg-primary-1 shadow-md',
            'transition-shadow hover:cursor-pointer hover:shadow-xl'
        ],
        contentWrapper: [
            'relative z-[1] flex flex-col',
            '@3xl:flex-row'
        ],
        topSection: 'flex min-w-0 flex-grow',
        favoriteButton: 'pointer-events-auto absolute top-3 left-3 z-[2]',
        imageContainer: [
            'h-[100px] w-[112px] shrink-0',
            '@3xl:h-[145px] @3xl:w-[128px]',
            '@5xl:h-[124px] @5xl:w-[192px]'
        ],
        image: 'h-full w-full',
        logoOverlay: 'flex items-center justify-center bg-primary-1 px-2 py-1',
        infoSection: 'flex min-w-0 flex-col justify-center gap-1 px-3',
        title: 'line-clamp-2 text-heading5 font-bold @3xl:text-heading4',
        subtitle: 'line-clamp-2 text-body3',
        attributeRow: 'flex items-center gap-2',
        reviewsSection: 'flex items-center gap-2',
        reviewsText: 'text-body3',
        middleSection: [
            'flex flex-col gap-2',
            '@3xl:flex-shrink-0 @3xl:flex-row @3xl:items-center @3xl:gap-4 @3xl:pr-4 @3xl:pl-0'
        ],
        dateBlocksContainer: [
            'mx-3 mt-3 flex flex-row rounded-lg bg-neutral-3',
            '@3xl:mx-0 @3xl:mt-0 @3xl:flex-col',
            '@5xl:mx-0 @5xl:mt-0 @5xl:flex-row'
        ],
        dateBlockDividerVertical: [
            'my-2 flex self-stretch',
            '@3xl:hidden',
            '@5xl:my-0 @5xl:flex'
        ],
        dateBlockDividerHorizontal: [
            'mx-2 hidden h-[1px]',
            '@3xl:flex',
            '@5xl:hidden'
        ],
        dateBlock: [
            'flex min-w-fit flex-1 flex-col items-center justify-center'
        ],
        dateBlockLabel: 'text-body3 font-bold text-neutral-13',
        dateBlockDate: 'text-center text-body2 whitespace-pre-line text-neutral-13',
        bottomSection: [
            'flex w-auto flex-col gap-2 px-3 pb-2',
            '@3xl:w-45 @3xl:p-0'
        ],
        priceSection: [
            'flex w-[150px] flex-col items-center',
            '@3xl:w-auto',
            '@5xl:w-[150px]'
        ],
        occupancyBlock: 'rounded-lg bg-neutral-3 p-3 text-center',
        occupancyText: 'text-body3 text-neutral-8',
        ctaContainer: 'pointer-events-auto flex w-full justify-center'
    },
    variants: {
        productType: {
            hotel: {
                dateBlock: [
                    'py-2',
                    '@3xl:p-3 @3xl:px-5',
                    '@5xl:px-3 @5xl:py-8'
                ]
            },
            rentalCar: {
                dateBlock: [
                    'py-1',
                    '@3xl:px-5 @3xl:py-1',
                    '@5xl:px-3 @5xl:py-6'
                ],
                imageContainer: 'flex flex-col',
                image: 'min-h-0 flex-1'
            },
            flight: {
                dateBlock: [
                    'py-1',
                    '@3xl:px-5 @3xl:py-1',
                    '@5xl:px-3 @5xl:py-6'
                ]
            }
        },
        hasPrice: {
            true: {},
            false: {}
        }
    },
    compoundVariants: [
        {
            productType: 'hotel',
            hasPrice: true,
            class: {
                contentWrapper: '@5xl:flex-row',
                bottomSection: [
                    'flex-row items-center justify-between',
                    '@3xl:flex-col'
                ]
            }
        },
        {
            productType: 'rentalCar',
            hasPrice: false,
            class: {
                bottomSection: [
                    'flex-col',
                    '@3xl:gap-2'
                ]
            }
        },
        {
            productType: 'flight',
            hasPrice: false,
            class: {
                bottomSection: [
                    'flex-col',
                    '@3xl:gap-2'
                ]
            }
        }
    ],
    defaultVariants: {
        productType: 'hotel',
        hasPrice: false
    }
});
export { recentSelectionVariants };
